import { Component, inject, Inject, OnInit } from '@angular/core';
import { RefusedVisaDetails } from '../../models/refused-visa-details';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Person } from '../../data/person';
import { NonNullableFormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { resolvePersonOption } from '../../../helpers/person.helpers';


@Component({
  selector: 'app-refused-visa-dialog',
  templateUrl: './refused-visa-dialog.component.html',
  styleUrl: './refused-visa-dialog.component.scss'
})
export class RefusedVisaDialogComponent implements OnInit {
    refusedVisaDetails!: RefusedVisaDetails;
    personOptions: Array<{ value: Person, label: string }> = [];

    formBuilder = inject(NonNullableFormBuilder);

    refusedVisaDetailsForm = this.formBuilder.group({
      refused: [''],
      person: [null as Person | null]
  
    });
  
    constructor(public dialogRef: MatDialogRef<RefusedVisaDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
     this.refusedVisaDetails = data.refusedVisaDetails;
     this.personOptions = data.personOptions;
  
    }

  ngOnInit(): void {

    this.initializeForm();
    this.applyValidators();

  }

  private initializeForm(): void{
    this.refusedVisaDetailsForm.patchValue({
      refused: this.refusedVisaDetails.refused,
      person: resolvePersonOption(this.refusedVisaDetails.person, this.personOptions)
    });

    this.refusedVisaDetailsForm.valueChanges.subscribe(formValue => {
      this.refusedVisaDetails.refused = formValue.refused || '';
      this.refusedVisaDetails.person = formValue.person || new Person();
    });

  }
  
    get dialogTitle(): string {
      return 'Add Visa Refused';
    }
  
      private applyValidators(): void {
        const refusedControl = this.refusedVisaDetailsForm.controls.refused;
        const personControl = this.refusedVisaDetailsForm.controls.person;
        refusedControl.setValidators([Validators.required]);
        personControl.setValidators([Validators.required]);
        refusedControl.updateValueAndValidity();
        personControl.updateValueAndValidity();
      }


cancel() {
  this.dialogRef.close();
}
ok() {
  if(this.refusedVisaDetailsForm.valid){
      this.dialogRef.close(this.refusedVisaDetails);
    }
    else{
      this.refusedVisaDetailsForm.markAllAsTouched();
      return;
    }
}
}
